export const toggleHidden = (element, hide = true) => {
    element === null || element === void 0 ? void 0 : element.classList.toggle('hidden', hide);
};
export const toggleVisible = (element, visible = true) => {
    element === null || element === void 0 ? void 0 : element.classList.toggle('hidden', !visible);
};
export const toggleDisabled = (element, disabled = true) => {
    element === null || element === void 0 ? void 0 : element.classList.toggle('disabled', disabled);
};
export const toggleNoValidate = (element, novalidate = true) => {
    element === null || element === void 0 ? void 0 : element.toggleAttribute('data-novalidate', novalidate);
};
/**
 * Сохраняет состояние формы в localStorage
 * @param form - Элемент формы
 * @param storageKey - Ключ для localStorage
 */
export function saveFormState(form, storageKey) {
    const data = {};
    const formData = new FormData(form);
    // 1. Собираем все выбранные значения (текст, селекты, отмеченные чекбоксы/радио)
    for (const [name, value] of formData.entries()) {
        // Если элементов с одинаковым name несколько (группа чекбоксов или multiple select)
        if (data[name] !== undefined) {
            if (!Array.isArray(data[name])) {
                data[name] = [data[name]];
            }
            data[name].push(value);
        }
        else {
            data[name] = value;
        }
    }
    // 2. Важный нюанс: сохраняем НЕОТМЕЧЕННЫЕ чекбоксы.
    // FormData не включает снятые чекбоксы. Если в HTML чекбокс стоит checked="checked",
    // а пользователь его снял, нам нужно запомнить, что он теперь false.
    for (const el of form.elements) {
        const input = el;
        if (input.type === 'checkbox' && !input.checked && input.name && data[input.name] === undefined) {
            data[input.name] = false;
        }
    }
    localStorage.setItem(storageKey, JSON.stringify(data));
}
/**
 * Восстанавливает состояние формы из localStorage
 * @param form - Элемент формы
 * @param storageKey - Ключ для localStorage
 */
export function restoreFormState(form, storageKey) {
    const json = localStorage.getItem(storageKey);
    if (!json)
        return;
    const data = JSON.parse(json);
    // Сбрасываем форму к HTML-значениям по умолчанию
    form.reset();
    for (const name in data) {
        const val = data[name];
        const els = form.elements.namedItem(name);
        if (!els)
            continue;
        // Приводим к массиву для единообразной обработки
        const elArray = (els instanceof RadioNodeList)
            ? Array.from(els)
            : [els];
        elArray.forEach(el => {
            if (el instanceof HTMLInputElement) {
                if (el.type === 'file')
                    return; // Пропускаем файлы
                if (el.type === 'checkbox') {
                    if (Array.isArray(val)) {
                        el.checked = val.includes(el.value);
                    }
                    else {
                        el.checked = (val === true || val === el.value);
                    }
                }
                else if (el.type === 'radio') {
                    el.checked = (el.value === val);
                }
                else {
                    el.value = val;
                }
            }
            else if (el instanceof HTMLSelectElement) {
                if (el.multiple) {
                    const vals = Array.isArray(val) ? val : [val];
                    Array.from(el.options).forEach(opt => {
                        opt.selected = vals.includes(opt.value);
                    });
                }
                else {
                    el.value = val;
                }
            }
            else if (el instanceof HTMLTextAreaElement) {
                el.value = val;
            }
        });
    }
}
/**
 * Опционально: функция для очистки сохраненного состояния
 * @param storageKey - Ключ для localStorage
 */
export function clearFormState(storageKey) {
    localStorage.removeItem(storageKey);
}
// Пример использования
document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('myForm');
    const storageKey = 'myFormData';
    if (form) {
        // Восстановление при загрузке
        restoreFormState(form, storageKey);
        // Автосохранение при изменении
        form.addEventListener('input', () => {
            saveFormState(form, storageKey);
        });
        // Обработчики кнопок
        const saveBtn = document.getElementById('saveBtn');
        const restoreBtn = document.getElementById('restoreBtn');
        const clearBtn = document.getElementById('clearBtn');
        if (saveBtn) {
            saveBtn.addEventListener('click', () => saveFormState(form, storageKey));
        }
        if (restoreBtn) {
            restoreBtn.addEventListener('click', () => restoreFormState(form, storageKey));
        }
        if (clearBtn) {
            clearBtn.addEventListener('click', () => {
                clearFormState(storageKey);
                form.reset();
            });
        }
    }
});
